export default {"src":"/_next/static/media/product-menu-hover.3ae89e48.svg","height":32,"width":32};